import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { SearchByPipe } from 'src/app/pipes/search-by-pipe/search-by.pipe';
import { Json2csvService } from 'csvtools-lib';
import { FilterByPipe } from 'src/app/pipes/filter-by-pipe/filter-by.pipe';

@Component({
  selector: 'app-devices-dashboard',
  templateUrl: './devices-dashboard.component.html',
  styleUrls: ['./devices-dashboard.component.scss']
})
export class DevicesDashboardComponent implements OnInit, OnDestroy {

  devices: DeviceBasic[];
  filteredDevices;
  filterOpts;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getDevicesSubscriptionRefresh: Subscription;
  getDevicesSubscription: Subscription;
  filterDevicesSubscription: Subscription;
  searchDevicesSubscription: Subscription;
  toggleDevicesDispositionSubscription: Subscription;
  exportDevicesDispositcionSubscription: Subscription;

  constructor(private devicesService: DevicesDevicesService,
              private userStorageService: UserStorageService,
              private json2csvService: Json2csvService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDevices();
    this.getDevicesSubscriptionRefresh = this.devicesService.refreshDevicesListen().subscribe(
      (res) => {
        this.getDevices();
      }
    );
    this.filterDevicesSubscription = this.devicesService.filterDevicesListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchDevicesSubscription = this.devicesService.searchDevicesListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleDevicesDispositionSubscription = this.devicesService.toggleDevicesDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
    this.exportDevicesDispositcionSubscription = this.devicesService.exportDevicesListen().subscribe(
      (res) => {
        this.exportDevicesList();
      }
    );
  }

  public exportDevicesList() {
    this.filteredDevices = new FilterByPipe().transform(this.devices, this.filterOpts);
    console.log(JSON.stringify(this.filteredDevices));
    if (this.filterKey) {
      this.filteredDevices = new SearchByPipe().transform(this.filteredDevices, [['DeviceName', 'DeviceModel', 'DeviceTypeName', 'DeviceSerialNumber', 'InternalId'], this.filterKey]);
    }
    const data = [];
    this.filteredDevices.forEach(d => {
      data.push([d.CenterName, d.DeviceName, d.DeviceModel, d.DeviceSerialNumber, d.DeviceTypeName, d.Location, d.Status, new Date(d.LastConnection).toLocaleDateString(), d.Mac, d.IpAddress, d.ConnectionDevice, d.WifiSsid]);
    });
    this.json2csvService.setBody(data, ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']);
    this.json2csvService.setHeader(['Center', 'Device', 'Model', 'Serial number', 'Type', 'Location', 'Status', 'Last connection', 'Mac', 'IP', 'Connection', 'Wifi SSID']);
    this.json2csvService.generateCSV('deviceList');
  }

  private getDevices() {
    this.getDevicesSubscription = this.devicesService.getDevicesBasic().pipe(
      tap(o => this.devices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-microchip', 'devices-page.devices'));
  }

  private setNoItemsConfig() {
    return {
      description: 'devices-page.devices not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getDevicesSubscriptionRefresh) { this.getDevicesSubscriptionRefresh.unsubscribe(); }
    if (this.getDevicesSubscription) { this.getDevicesSubscription.unsubscribe(); }
    if (this.filterDevicesSubscription) { this.filterDevicesSubscription.unsubscribe(); }
    if (this.searchDevicesSubscription) { this.searchDevicesSubscription.unsubscribe(); }
    if (this.toggleDevicesDispositionSubscription) { this.toggleDevicesDispositionSubscription.unsubscribe(); }
    if (this.exportDevicesDispositcionSubscription) { this.exportDevicesDispositcionSubscription.unsubscribe(); }
  }

}
